import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Delivery } from "../../../../../utils/backend-types";
import type { Contract } from "../../../DeliveryOverview.types";
import { MissingDeliveriesInfo } from "../../MissingDeliveriesInfo/MissingDeliveriesInfo";
import { getDeliveryCountFromContract } from "../utils/getDeliveryCountFromContract";

export function getDeliveriesColumn(
  deliveries: Array<Delivery>
): MRT_ColumnDef<Contract> {
  return {
    accessorKey: "deliveries",
    header: "Lieferungen",
    size: 120,
    enableColumnFilter: false,
    sortingFn: (rowA, rowB) => {
      const countA = getDeliveryCountFromContract(deliveries, rowA.original.id);
      const countB = getDeliveryCountFromContract(deliveries, rowB.original.id);
      return countA - countB;
    },
    Cell: ({ row }) => (
      <MissingDeliveriesInfo
        numberOfDeliveries={getDeliveryCountFromContract(
          deliveries,
          row.original.id
        )}
      />
    )
  };
}
